// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__z-CDM","itemTitle":"ClientEmergencyInfo_itemTitle__2w80M","itemText":"ClientEmergencyInfo_itemText__1_rkD"};